module.exports = __webpack_public_path__ + "static/media/command-key.ddc636e2.svg";